import React from "react";

import { ProgressSpinner } from "primereact/progressspinner";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import useRequiredFields from "../../../../hooks/useRequiredFields";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);

  const { checkRequiredFields } = useRequiredFields();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const displayError = (fieldName) => {
    if (error && error[fieldName]) {
      return <div className="text-danger small">{error[fieldName]}</div>;
    }
    return null;
  };

  const formSubmit = () => {
    setLoading(true);
    setError({}); // clear old errors
    if (checkRequiredFields()) {
      Http.post("/shift", inputs)
        .then((res) => {
          setLoading(false);
          navigate("/shift", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch((e) => {
          setLoading(false);
          if (e.response?.data?.errors) {
            setError(e.response.data.errors);
          }
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Shift</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Create Shift
            </h6>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label className="font-weight-bold">
                      Shift Name <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={inputs.name || ""}
                      onChange={handleChange}
                      placeholder="Input Name"
                      data-required // Add this custom attribute to make this field required
                    />
                    {displayError("name")}
                  </div>
                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold">
                      Start Time <i className="fa fa-star required"></i>
                    </label>

                    <input
                      type="time"
                      className="form-control"
                      name="start_time"
                      value={inputs.start_time || ""}
                      onChange={handleChange}
                      placeholder="Start time"
                      data-required
                    />
                    {displayError("start_time")}
                  </div>
                </div>
                <div className="row mt-1">
                  {/* col */}
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold">
                      End Time <i className="fa fa-star required"></i>
                    </label>

                    <input
                      type="time"
                      className="form-control"
                      name="end_time"
                      value={inputs.end_time || ""}
                      onChange={handleChange}
                      placeholder="End time"
                      data-required
                    />
                    {displayError("end_time")}
                  </div>
                  <div className="col-lg mg-t-10 mg-lg-t-0">
                    <label className="font-weight-bold">
                      Buffer Time <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="time"
                      className="form-control"
                      name="buffer_time"
                      value={inputs.buffer_time || ""}
                      onChange={handleChange}
                      placeholder="Buffer time"
                      data-required
                    />
                    {displayError("buffer_time")}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                    >
                      <i className="fa fa-send mg-r-10"></i> Create
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
